import { useState } from 'react';

import { Cookies } from '@/app/libs/cookies/instance';
import { DeviceDetector } from '@/app/utils/device-detector';
import { Button } from '@/view/components/elements/button';

const ONE_YEAR_IN_DAYS = 365;

export const CookiesConsent = () => {
  const [isCookieSet, setCookie] = useState<boolean | undefined>(
    Cookies.get('cookieConsent') as boolean | undefined,
  );

  function accept() {
    Cookies.set('cookieConsent', 'true', { expires: ONE_YEAR_IN_DAYS });
    setCookie(true);
  }

  function reject() {
    Cookies.set('cookieConsent', 'false');
    setCookie(false);
  }

  if (DeviceDetector.isTV()) return;

  if (isCookieSet !== undefined) return;

  return (
    <div className="fixed bg-background-primary bottom-4 left-1/2 transform -translate-x-1/2 p-4 rounded-lg shadow-lg w-4/5 md:w-2/3">
      <div className="w-full h-full flex items-center gap-6 flex-col md:flex-row">
        <span className="text-xs">
          Utilizamos cookies essenciais para melhorar a navegação do usuário em nosso site, como
          aqueles que ajudam a identificar as rotas que você acessa dentro do sistema. Esses cookies
          são utilizados exclusivamente para otimizar a experiência de navegação. Para mais
          informações, consulte nossa <span className="underline">Politica de Cookies</span>.
        </span>
        <div className="flex gap-3 flex-row lg:flex-row md:flex-col-reverse">
          <Button
            variant="secondary"
            size="small"
            onClick={reject}
            aria-label="rejeitar cookies"
            data-testid="reject-cookies-button"
          >
            Rejeitar
          </Button>
          <Button
            size="small"
            onClick={accept}
            aria-label="aceitar cookies"
            data-testid="accept-cookies-button"
          >
            Aceitar
          </Button>
        </div>
      </div>
    </div>
  );
};
